var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.3333 1.44434H5.52817V2.83318H17.3333V1.44434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.3333 6.30469H5.52817V7.69354H17.3333V6.30469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.3333 11.166H5.52817V12.5549H17.3333V11.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.0558 3.52768C2.82284 3.52768 3.44465 2.90588 3.44465 2.13884C3.44465 1.37181 2.82284 0.75 2.0558 0.75C1.28877 0.75 0.666962 1.37181 0.666962 2.13884C0.666962 2.90588 1.28877 3.52768 2.0558 3.52768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.0558 8.38901C2.82284 8.38901 3.44465 7.7672 3.44465 7.00017C3.44465 6.23313 2.82284 5.61133 2.0558 5.61133C1.28877 5.61133 0.666962 6.23313 0.666962 7.00017C0.666962 7.7672 1.28877 8.38901 2.0558 8.38901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.0558 13.2494C2.82284 13.2494 3.44465 12.6276 3.44465 11.8605C3.44465 11.0935 2.82284 10.4717 2.0558 10.4717C1.28877 10.4717 0.666962 11.0935 0.666962 11.8605C0.666962 12.6276 1.28877 13.2494 2.0558 13.2494Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListWhite);
export default __webpack_public_path__ + "static/media/list_white.010c33f4b5cac20c04c26a8875a43230.svg";
export { ForwardRef as ReactComponent };